export default __webpack_public_path__ + "static/media/enricocattabiani.7bb4aa03.png";